import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from './button.js';
/**
 * Футер keyset-пагинации под списком: «Показать ещё» / «Загружаем…» /
 * «Показаны все … (N)». Канон пагинации админки (курсор + `useInfiniteQuery`
 * + кнопка) — до выноса футер побайтно повторялся в истории запросов
 * платёжного сервиса и в публикациях «Контента».
 */
export function LoadMoreFooter({ hasNextPage, isFetchingNextPage, onLoadMore, shown, allShownLabel = (n) => `Показаны все записи (${n})`, moreLabel = 'Показать ещё', loadingLabel = 'Загружаем…', autoLoad = false, }) {
    const sentinel = React.useRef(null);
    // Свежие значения — без пересоздания наблюдателя на каждый рендер.
    const latest = React.useRef({ hasNextPage, isFetchingNextPage, onLoadMore });
    latest.current = { hasNextPage, isFetchingNextPage, onLoadMore };
    React.useEffect(() => {
        const el = sentinel.current;
        const IO = globalThis
            .IntersectionObserver;
        if (!autoLoad || !hasNextPage || !el || !IO)
            return;
        const io = new IO((entries) => {
            const l = latest.current;
            if (entries.some((e) => e.isIntersecting) && l.hasNextPage && !l.isFetchingNextPage) {
                l.onLoadMore();
            }
        });
        io.observe(el);
        return () => io.disconnect();
    }, [autoLoad, hasNextPage, isFetchingNextPage]);
    if (hasNextPage) {
        return (_jsx("div", { ref: sentinel, className: "flex justify-center", children: _jsx(Button, { type: "button", variant: "secondary", disabled: isFetchingNextPage, onClick: onLoadMore, children: isFetchingNextPage ? loadingLabel : moreLabel }) }));
    }
    if (shown === 0)
        return null;
    return (_jsx("p", { className: "text-center text-xs text-[var(--color-text-muted)]", children: allShownLabel(shown) }));
}
//# sourceMappingURL=load-more-footer.js.map